import { App } from 'vue';

export default function install(app: App): void {
	 
	app.config.globalProperties.$toastError = function toastError(err: string) {
		this.$bvToast.toast(
			err,
			{
				solid: true,
				variant: 'danger',
			},
		);
	};

	 
	app.config.globalProperties.$toastSuccess = function toastSuccess(message: string) {
		this.$bvToast.toast(
			message,
			{
				solid: true,
				variant: 'success',
			},
		);
	};
}
